const ChoosingCareerChallenge1InitialText ="You are a career counselor at a major university. " +
    "You are currently working with several individuals to try to help them find a career that " +
    "is best for them.  Review the job choices and list of skills required.  Then match the " +
    "individuals to the job that best fits their skills and interests. Each person will match " +
    "to only one job and each job will have only one person.  Click on the <Done> button to " +
    "confirm your choices."
        
export default ChoosingCareerChallenge1InitialText 
 